<template>
    <div class="w-full h-full py-3 sm:px-6">
        <div v-for="(chats, index) in chatMessages" :key="index + 'chats_msg'">
            <div class="date_label">
                <hr />
                <span>{{ getDateLabel(chats[0].timestamp) }}</span>
                <hr />
            </div>
            <div v-for="(chat, index) in chats" :key="index + 'chats_msg'"
                :class="[isSender(chat) ? 'sender' : 'reciever']">
                <div>
                    {{ chat.content || "" }}
                </div>
                <p>
                    <span><img v-if="hasIsSeen(chat)" src="../../icons/seen.svg" class="mr-1" />{{
                        refinetime(chat.timestamp) }} </span>
                </p>
            </div>
        </div>

        <!-- <div class="sender">
            <div>
                Thank you. Please call me when you’re outside. The gate might be locked.
            </div>
            <p>
                <span> 2:15 PM</span>
            </p>
        </div> -->
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: "ChatMessages",
    props: {
        shipping: {
            type: Object,
            default: () => ({})
        },
        chatMessages: {
            type: Array
        }
    },
    data() {
        return {

        }
    },
    methods: {
        getDateLabel(timestamp) {
            const date = moment(timestamp)
            const today = moment().startOf("day")
            const yesterday = moment().subtract(1, "day").startOf("day")

            if (date.isSame(today, "day")) {
                return "today"
            }
            if (date.isSame(yesterday, "day")) {
                return "yesterday"
            }
            return date.format("Do MMM YYYY")

        },
        hasIsSeen(chat) {
            chat?.seenBy?.length > 1
        },
        isSender(chat) {
            return this.$store.getters.user.id === chat?.senderId
        },
        refinetime(val) {
            return moment.utc(val).local().format('h:mm A')
        }
    }
}
</script>

<style lang="scss" scoped>
.date_label{
   @apply flex items-center justify-between my-2 mb-6;
   hr{
    @apply w-[50%] opacity-50;
   }
   span{
    @apply mx-4 opacity-60 capitalize whitespace-nowrap;
   }
}
.reciever {
    @apply w-full mt-3;

    div {
        @apply text-sm bg-primary-blue/10 text-black-default py-3 px-2 w-full;
        border-radius: 10px 10px 10px 0px;
    }

    p {
        span {
            @apply opacity-50 text-xs flex justify-start pr-2 pt-[4px]
        }
    }
}

.sender {
    @apply w-full mt-3 whitespace-pre-line;

    div {
        @apply text-sm bg-primary-navy text-white py-3 px-2 w-full;
        border-radius: 10px 10px 0px 10px;
    }

    p {

        span {
            @apply opacity-50 text-xs flex justify-end pr-2 pt-[4px]
        }
    }
}
</style>